/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ZteUploadRequestMutationVariables = Types.Exact<{
  input: Types.ZteUploadRequestInput;
}>;


export type ZteUploadRequestMutation = { __typename?: 'Mutation', zteUploadRequest: { __typename?: 'ZteUploadRequestPayload', uploadUrl: string } };


export const ZteUploadRequestDocument = gql`
    mutation zteUploadRequest($input: ZteUploadRequestInput!) {
  zteUploadRequest(input: $input) {
    uploadUrl
  }
}
    `;
export type ZteUploadRequestMutationFn = ApolloReactCommon.MutationFunction<ZteUploadRequestMutation, ZteUploadRequestMutationVariables>;

/**
 * __useZteUploadRequestMutation__
 *
 * To run a mutation, you first call `useZteUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZteUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zteUploadRequestMutation, { data, loading, error }] = useZteUploadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZteUploadRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ZteUploadRequestMutation, ZteUploadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ZteUploadRequestMutation, ZteUploadRequestMutationVariables>(ZteUploadRequestDocument, options);
      }
export type ZteUploadRequestMutationHookResult = ReturnType<typeof useZteUploadRequestMutation>;
export type ZteUploadRequestMutationResult = ApolloReactCommon.MutationResult<ZteUploadRequestMutation>;
export type ZteUploadRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ZteUploadRequestMutation, ZteUploadRequestMutationVariables>;